module.exports = __webpack_public_path__ + "img/icon-coupon.e0e1ef66.svg";